import type {ReactNode} from 'react';
import type {CanvasChatMessage,CanvasImage,ChatImageSlot} from './canvas-types';
import {chatImageGroups} from './chat-image-groups';

/** Pending and completed images occupy the same message-owned gallery. */
export function ChatImageGallery({message,images,renderSlot}:{message:CanvasChatMessage;images:readonly CanvasImage[];renderSlot:(slot:ChatImageSlot)=>ReactNode}){
 const terminal=message.playbookProgress?.isDone===true;
 const slots=message.imageSlots?.filter(slot=>!slot.failed&&(!terminal||!!slot.resolved))??[];
 if(!slots.length)return null;
 return <div className="flex flex-wrap gap-3 mt-3 items-start" data-testid={`chat-image-gallery-${message.id}`}>
  {chatImageGroups(slots,images).map(group=><div key={group.key} data-concept-group={group.key} className="flex gap-2 items-start max-w-full min-w-0">
   {group.slots.map(slot=><div key={slot.index} className="contents">{renderSlot(slot)}</div>)}
  </div>)}
 </div>;
}
